<template lang="pug">
.container
    mainHeader
    headerBlock
    #staff
        .hero.img
            img.photo.-pc(src="@/assets/img/photo/staff/top.png")
            img.photo.-sp(src="@/assets/img/photo/staff/sp_top.png")
        .intro
            img.text.-pc(src="@/assets/img/photo/staff/text.png")
            img.text.-sp(src="@/assets/img/photo/staff/sp_text.svg")
        .shikaku
            h3.head
                | 色々な分野の資格を持っ
                span.space たスタッフ
            ul
                li(v-for="item in shikaku") {{ item }}
        .member
            .item(v-for="item in member"): img(
                :src="require('@/assets/img/photo/staff/' + item + '.png')"
            )
        //- .catch.catch01
        //-     .photo: img(src="@/assets/img/photo/staff/42.png")
        //-     .text.pc: img(src="@/assets/img/photo/staff/catch01.svg")
        //-     .text.sp: img(src="@/assets/img/photo/staff/catch_sp1.svg")
        //- .catch.catch02
        //-     .photo: img(src="@/assets/img/photo/staff/43.png")
        //-     .text.pc: img(src="@/assets/img/photo/staff/catch02.svg")
        //-     .text.sp: img(src="@/assets/img/photo/staff/catch_sp2.svg")
        backtoTop.back
    footerBlock
</template>

<style lang="scss" scoped>
img {
    width: 100%;
}

.-pc {
    display: none;
    @media #{$pc} {
        display: block;
    }
}

.-sp {
    @media #{$pc} {
        display: none;
    }
}

#staff {
    @include container;

    > .hero {
        @include shadow;
        width: 100%;
        margin: 25px auto;
        overflow: hidden;
        position: relative;

        @media #{$pc} {
            width: 851px;
            height: 508px;
            margin: 75px auto;
        }

        > .photo {
            width: 100%;
        }

        > .photo.-pc {
            display: none;
            transform: scale(1.04);
            @media #{$pc} {
                display: block;
            }
        }

        > .photo.-sp {
            transform: scale(1.06) translateY(1%);
            @media #{$pc} {
                display: none;
            }
        }
    }

    > .intro {
        margin: 55px auto;
        @media #{$phone} {
            width: 95%;
        }
        @media #{$tab} {
            width: 50%;
        }
        @media #{$pc} {
            width: 595px;
            margin: 75px auto;
        }
        > .text {
            width: 100%;
        }
    }

    > .shikaku {
        padding: 55px 16px;
        margin: 48px 0;
        background: #fff;
        color: $color-text;
        display: flex;
        flex-direction: column;
        justify-content: center;

        @media #{$pc} {
            width: 844px;
            height: 320px;
            margin: 75px auto 51px;
            padding: 75px 0;
        }

        > .head {
            text-align: center;
            margin-bottom: 16px;
            font-weight: normal;
            letter-spacing: -1px;
            // > .space {
            //     letter-spacing: -5px;
            // }

            @media #{$pc} {
                margin-bottom: 40px;
                font-size: 1.75em;
                letter-spacing: 0px;
            }
            > br {
                @media #{$pc} {
                    display: none;
                }
            }
        }
        > ul {
            margin: 0 auto;
            transform: translateX(-8px);
            @media screen and (max-width: 960px) and (-ms-high-contrast: none) {
                text-align: center;
                line-height: 2rem;
            }

            @media #{$pc} {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                width: 60%;
                transform: translateX(24px);
            }
        }
        > ul > li {
            @media #{$pc} {
                width: 50%;
                margin: 3px 0;
            }
        }
    }

    > .member {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        > .item {
            width: 95%;
            margin: 6px auto;
            overflow: hidden;
            //@include shadow;

            @media #{$pc} {
                width: 370px;
                height: 270px;
                margin: 24px 32px;
            }
        }

        > .item > img {
            width: 100%;
            object-fit: cover;
        }
    }

    > .catch {
        margin: 48px 0;
        @media #{$pc} {
            display: flex;
        }

        > .photo {
            width: 375px;
            height: 178px;
            margin: 0 auto;
            @include shadow;

            @media #{$pc} {
                width: 596px;
                height: 260px;
                margin: 0;
            }
        }

        > .photo > img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        > .text {
            flex-grow: 1;
            position: relative;
        }

        > .text.pc {
            display: none;
            @media #{$pc} {
                display: block;
            }
        }

        > .text.sp {
            margin: 16px auto;
            display: flex;
            justify-content: center;
            @media #{$pc} {
                display: none;
            }
        }

        > .text > img {
            @media #{$pc} {
                position: absolute;
            }
        }

        &.catch01 {
            > .text > img {
                width: 244px;
                @media #{$pc} {
                    width: 132px;
                    height: 54px;
                    bottom: 30%;
                    left: 30px;
                }
            }
        }

        &.catch02 {
            flex-direction: row-reverse;
            > .text > img {
                width: 264px;
                @media #{$pc} {
                    width: 113px;
                    height: 82px;
                    bottom: 35%;
                    right: 72px;
                }
            }
        }
    }

    > .back {
        @media #{$pc} {
            margin-top: 40px;
        }
    }
}
</style>


<script>
import mainHeader from "@/components/header-menu";
import headerBlock from "@/components/pc-header";
import footerBlock from "@/components/footer-block";
import backtoTop from "@/components/backto-top";
import mobileHeader from "@/components/mobile-header";

export default {
    components: {
        mainHeader,
        headerBlock,
        footerBlock,
        backtoTop,
        mobileHeader,
    },
    mounted() {
        window.scroll(0, 0);
    },
    data() {
        return {
            shikaku: [
                "2級建築士",
                "愛犬家住宅コーディネーター",
                "インテリアコーディネーター",
                "DIYリフォームアドバイザー",
                "整理収納アドバイザー",
                "ISD個性心理学インストラクター",
                "住空間収納プランナー",
                "色彩検定2級",
            ],
            member: ["01", "02", "03", "04", "05", "06"],
        };
    },
};
</script>
